import {cs}        from "./chain-services";
import {fragments} from "./fragments";
import {Interval}  from "./interval";
import {UseState}  from "./use-state";

export const IntervalWatch = ({getValue, delay=1000, next}) => cs(
    ["state", (_, next) => UseState({next})],
    ({state}, next) => fragments(
        next(),
        Interval({
            delay,
            action: () => {
                const value = getValue();
                if (state.value !== value) {
                    state.onChange(value);
                }
            },
        }),
    ),
    ({state}) => next(state.value),
);
